import { StartUpDataContext } from "src/contexts/startUpData.tsx";
import { AavoViewsDispatchContext } from "./aavoViewsContext";
import { Primitive } from "src/types/primitive.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export type OpenLegacyViewFunction = (
	idAnchor: string,
	viewParams: Record<string, Primitive>,
) => void;

export const useOpenLegacyView = (): OpenLegacyViewFunction => {
	const startUpData = useContextOrThrow(StartUpDataContext);
	const dispatch = useContextOrThrow(AavoViewsDispatchContext);
	return (idAnchor: string, viewParams: Record<string, Primitive>) => {
		const view = Object.values(startUpData?.views ?? {}).find((v) => {
			return v.view.idAnchor === idAnchor;
		});
		if (view === undefined) {
			throw Error(`Can not open view ${idAnchor}`);
		}
		dispatch({
			type: "openLegacyModal",
			modalViewState: {
				view: view,
				sourceViewId: null,
				viewParams: Object.entries(viewParams).map(([key, value]) => ({ key, value })),
			},
		});
	};
};
